// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questionitem {
  margin-top: 40px;

}

.courseitem:hover {
  cursor: pointer;
  border-style: none solid none none;
  border-color: blue;
}

.box {
  height: auto;
  padding: 10px;
  background-color: rgb(241, 235, 235);
  border-radius: 15px;
  margin-top: 10px;
}

.module {

  padding: 10px;
  background-color: rgb(241, 235, 235);
  border-radius: 15px;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: x-large;
  font-weight: bold;

}
.module1 {
  padding: 1px;
  border-radius: 15px;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: larger;
  font-weight: bold;
  text-align: left;
}
.module2 {
  padding: 1px;
  border-radius: 15px;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: larger;
  font-weight: bold;
  text-align: left;
  float: inline-end;
}

.queqty {
  text-align: right;
  text-wrap: nowrap;
}

.submitbtn {
 margin: 0;
  position: relative;

}
@media (min-width: 768px) and (max-width: 1024px) {
  .queqty {
    display: flex;
 width: 13rem;
  }

}
@media (max-width: 767px) {
  .mx-3{
   margin-right: 0px !important;
   margin-left: 0px !important;
  }
  .module2{
    float: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/question/QuestionItem.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,6EAA6E;EAC7E,kBAAkB;EAClB,iBAAiB;;AAEnB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,6EAA6E;EAC7E,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,6EAA6E;EAC7E,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;CACC,SAAS;EACR,kBAAkB;;AAEpB;AACA;EACE;IACE,aAAa;CAChB,YAAY;EACX;;AAEF;AACA;EACE;GACC,4BAA4B;GAC5B,2BAA2B;EAC5B;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".questionitem {\r\n  margin-top: 40px;\r\n\r\n}\r\n\r\n.courseitem:hover {\r\n  cursor: pointer;\r\n  border-style: none solid none none;\r\n  border-color: blue;\r\n}\r\n\r\n.box {\r\n  height: auto;\r\n  padding: 10px;\r\n  background-color: rgb(241, 235, 235);\r\n  border-radius: 15px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.module {\r\n\r\n  padding: 10px;\r\n  background-color: rgb(241, 235, 235);\r\n  border-radius: 15px;\r\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\r\n  font-size: x-large;\r\n  font-weight: bold;\r\n\r\n}\r\n.module1 {\r\n  padding: 1px;\r\n  border-radius: 15px;\r\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\r\n  font-size: larger;\r\n  font-weight: bold;\r\n  text-align: left;\r\n}\r\n.module2 {\r\n  padding: 1px;\r\n  border-radius: 15px;\r\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\r\n  font-size: larger;\r\n  font-weight: bold;\r\n  text-align: left;\r\n  float: inline-end;\r\n}\r\n\r\n.queqty {\r\n  text-align: right;\r\n  text-wrap: nowrap;\r\n}\r\n\r\n.submitbtn {\r\n margin: 0;\r\n  position: relative;\r\n\r\n}\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  .queqty {\r\n    display: flex;\r\n width: 13rem;\r\n  }\r\n\r\n}\r\n@media (max-width: 767px) {\r\n  .mx-3{\r\n   margin-right: 0px !important;\r\n   margin-left: 0px !important;\r\n  }\r\n  .module2{\r\n    float: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
